import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/bins`;
export const GEO_CODING_URL = `${process.env.REACT_APP_GEO_CODING_API}`;
export const GEO_CODING_VERSION = `${process.env.REACT_APP_GEO_CODING_API_FORMAT}`;

// CREATE =>  POST: add a new product to the server
export function createBin(bin) {
    return axios.post(API_URL, { ...bin });
}

// READ
export function getAllBins() {
    return axios.get(API_URL);
}

export function getPaginatedBins(queryParams) {
    return axios.post(`${API_URL}/list`, { ...queryParams });
}

export function getBinById(binId) { 
    return axios.get(`${API_URL}/${binId}`);
}

export function getGeoCodingPosition(values) {
    const { addressCountry, addressPostalCode, addressStreet } = values;
    // let building = addressBuildingName === null ? "" : addressBuildingName;
    let street = addressStreet === null ? "" : addressStreet;
    let country = addressCountry === null ? "" : addressCountry;
    let postal = addressPostalCode === null ? "" : addressPostalCode;
    const result = axios.get(`${GEO_CODING_URL}?q=${street} ${country},${postal}&format=${GEO_CODING_VERSION}`);
    return result
}


// // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// // items => filtered/sorted result
// export function findProducts(queryParams) {
//     return axios.post(`${API_URL}/find`, { queryParams });
// }

// UPDATE => PUT: update the bin on the server
export function updateBin(binId, bin) {
    return axios.put(`${API_URL}/${binId}`, { ...bin });
}


// DELETE => delete the product from the server
export function deleteBin(binId) {
    return axios.delete(`${API_URL}/${binId}`);
}
